module.exports = ":host {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.ssf-agreement__text {\n  margin: 0 0 0 0.7rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/agreement/agreement.component.scss
// module id = 798
// module chunks = 3